// import i18n from '@/lang/lang'
// import router from '@/router'
import MatchPointHelper from './MatchTypes/MatchPointHelper'
import MatchTimeHelper from './MatchTypes/MatchTimeHelper'
import MatchBaseballHelper from './MatchTypes/MatchBaseballHelper'
// import SportHelper from './SportHelper'
const debug = require('debug')('OD::Lib:MatchHelper')

const libLogs = false

export default {
  config(sport) {
    if (libLogs) debug('config', { sport })
    const base = { type: sport.type || 'pointBase' }
    switch (base.type) {
      case 'pointBase':
        return MatchPointHelper.config(sport)
      case 'timeBase':
        return MatchTimeHelper.config(sport)
      case 'baseballBase':
        return MatchBaseballHelper.config(sport)
      default:
        debug('ERROR', 'Type not found', base.type)
    }
  },
  matchSetEnd(config, set, i) {
    if (libLogs) debug('matchSetEnd', { config, set, i })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.matchSetEnd(config, set, i)
      case 'timeBase':
        return MatchTimeHelper.matchSetEnd(config, set, i)
      case 'baseballBase':
        return MatchBaseballHelper.matchSetEnd(config, set, i)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  getMatchResult(config, match) {
    if (libLogs) debug('getMatchResult', { config, match })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.getMatchResult(config, match)
      case 'timeBase':
        return MatchTimeHelper.getMatchResult(config, match)
      case 'baseballBase':
        return MatchBaseballHelper.getMatchResult(config, match)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  isMatchOnline(config, match, matchFinished) {
    if (libLogs) debug('isMatchOnline', { config, match, matchFinished })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.isMatchOnline(config, match, matchFinished)
      case 'timeBase':
        return MatchTimeHelper.isMatchOnline(config, match, matchFinished)
      case 'baseballBase':
        return MatchBaseballHelper.isMatchOnline(config, match, matchFinished)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  isMatchStarted(config, match) {
    if (libLogs) debug('isMatchStarted', { config, match })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.isMatchStarted(config, match)
      case 'timeBase':
        return MatchTimeHelper.isMatchStarted(config, match)
      case 'baseballBase':
        return MatchBaseballHelper.isMatchStarted(config, match)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  isMatchFinish(config, match, result) {
    if (libLogs) debug('isMatchFinish', { config, match, result })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.isMatchFinish(config, match, result)
      case 'timeBase':
        return MatchTimeHelper.isMatchFinish(config, match, result)
      case 'baseballBase':
        return MatchBaseballHelper.isMatchFinish(config, match, result)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  isButtonDisabled(control, config, match, i, action, team, matchFinished) {
    if (libLogs)
      debug('isButtonDisabled', { control, config, match, i, action, team, matchFinished })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.isButtonDisabled(
          control,
          config,
          match,
          i,
          action,
          team,
          matchFinished
        )
      case 'timeBase':
        return MatchTimeHelper.isButtonDisabled(
          control,
          config,
          match,
          i,
          action,
          team,
          matchFinished
        )
      case 'baseballBase':
        return MatchBaseballHelper.isButtonDisabled(
          control,
          config,
          match,
          i,
          action,
          team,
          matchFinished
        )
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
  getMaxNumDowntimesBySet(config) {
    if (libLogs) debug('getMaxNumDowntimesBySet', { config })
    switch (config.type) {
      case 'pointBase':
        return MatchPointHelper.getMaxNumDowntimesBySet(config)
      case 'timeBase':
        return MatchTimeHelper.getMaxNumDowntimesBySet(config)
      case 'baseballBase':
        return MatchBaseballHelper.getMaxNumDowntimesBySet(config)
      default:
        debug('ERROR', 'Type not found', config.type)
    }
  },
}
